export const MIN_TIME_VALUE = 0;
export const MAX_TIME_VALUE = 24 * 60 * 60 - 1;
export enum DayPart {
  AM = 'AM',
  PM = 'PM',
}
export enum TimeInputTypes {
  HOURS = 'hours',
  MINUTES = 'minutes',
  SECONDS = 'seconds',
}

export const TIME_INPUT_TYPES_VALUES = {
  [TimeInputTypes.SECONDS]: 1,
  [TimeInputTypes.MINUTES]: 60,
  [TimeInputTypes.HOURS]: 60 * 60,
  [DayPart.AM]: 0,
  [DayPart.PM]: 12 * 60 * 60,
};

export const TIME_INPUT_SECTORS: { order: number, type: TimeInputTypes }[] = [
  { order: 1, type: TimeInputTypes.HOURS },
  { order: 2, type: TimeInputTypes.MINUTES },
  { order: 3, type: TimeInputTypes.SECONDS },
];
